import { PagedResultRequest } from '../../../shared/models/PagedResultRequest';
import { VisibilityTypes } from './JobListModel';

export class JobRequest extends PagedResultRequest {
  subBrandIdentifier: string;
  visibilityType: VisibilityTypes;
  internalJobBoardIdentifier: string;
  getFacets: boolean;
}
